var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.793,
    height: 63.865,
    viewBox: "0 0 63.793 63.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1696",
    "data-name": "Ellipse 1696",
    cx: 30.942,
    cy: 30.942,
    rx: 30.942,
    ry: 30.942,
    transform: "translate(0.769 0.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4133",
    "data-name": "Group 4133",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1701",
    "data-name": "Ellipse 1701",
    cx: 25.552,
    cy: 25.552,
    rx: 25.552,
    ry: 25.552,
    transform: "translate(6.373 6.388)",
    fill: "#00aced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    transform: "translate(9.434 10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4121",
    "data-name": "Group 4121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4118",
    "data-name": "Group 4118",
    transform: "translate(0 4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13923",
    "data-name": "Path 13923",
    d: "M6011.854,1511.2a1.2,1.2,0,0,1-1.2-1.2,22.493,22.493,0,0,1,7.731-16.97,1.2,1.2,0,0,1,1.573,1.807,20.1,20.1,0,0,0-6.908,15.164A1.2,1.2,0,0,1,6011.854,1511.2Z",
    transform: "translate(-6010.656 -1492.734)",
    fill: "#78dfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4120",
    "data-name": "Group 4120",
    transform: "translate(10.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4119",
    "data-name": "Group 4119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13924",
    "data-name": "Path 13924",
    d: "M6135.751,1447.755a1.2,1.2,0,0,1-.593-2.239,22.412,22.412,0,0,1,4.457-1.93,1.2,1.2,0,0,1,.708,2.289,20,20,0,0,0-3.979,1.724A1.192,1.192,0,0,1,6135.751,1447.755Z",
    transform: "translate(-6134.552 -1443.532)",
    fill: "#78dfff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4124",
    "data-name": "Group 4124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13925",
    "data-name": "Path 13925",
    d: "M5934.121,1387.879a31.933,31.933,0,1,1,22.585-54.51,1.2,1.2,0,0,1-1.694,1.694,29.545,29.545,0,1,0,0,41.782,1.2,1.2,0,0,1,1.694,1.694A31.845,31.845,0,0,1,5934.121,1387.879Z",
    transform: "translate(-5902.196 -1324.014)",
    fill: "#00aced"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(60.808 34.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13926",
    "data-name": "Path 13926",
    d: "M6602.494,1723.438a1.2,1.2,0,0,1-1.174-1.445c.188-.89.335-1.8.44-2.7a1.2,1.2,0,1,1,2.379.275c-.112.977-.272,1.96-.475,2.922A1.2,1.2,0,0,1,6602.494,1723.438Z",
    transform: "translate(-6601.294 -1718.229)",
    fill: "#00aced"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(57.892 16.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13927",
    "data-name": "Path 13927",
    d: "M6572.478,1526.479a1.2,1.2,0,0,1-1.194-1.116,29.458,29.458,0,0,0-3.368-11.817,1.2,1.2,0,1,1,2.115-1.123,31.852,31.852,0,0,1,3.643,12.777,1.2,1.2,0,0,1-1.113,1.277Z",
    transform: "translate(-6567.776 -1511.786)",
    fill: "#00aced"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4131",
    "data-name": "Group 4131",
    transform: "translate(18.692 22.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13928",
    "data-name": "Path 13928",
    d: "M6117.089,1602.8a14.215,14.215,0,0,0,7.2-1.146,12.668,12.668,0,0,0,2.9-1.768,9.169,9.169,0,0,1-1.672-.271,6.927,6.927,0,0,1-3.991-2.945,6.759,6.759,0,0,1-.739-1.559c.077.005.135,0,.191.013a6.8,6.8,0,0,0,2.726-.112.445.445,0,0,0,.137-.06,6.962,6.962,0,0,1-4.692-3.552,6.76,6.76,0,0,1-.805-3.282,7.658,7.658,0,0,0,1.513.607,6.024,6.024,0,0,0,1.575.222A6.94,6.94,0,0,1,6118.4,1583a6.642,6.642,0,0,1,.912-3.243,19.722,19.722,0,0,0,10.231,6.587,18.691,18.691,0,0,0,4.039.621c-.02-.122-.034-.219-.052-.316a6.872,6.872,0,0,1,5.207-7.984,6.742,6.742,0,0,1,6.5,1.872.271.271,0,0,0,.278.092,14.016,14.016,0,0,0,4-1.51c.053-.03.107-.058.2-.107-.028.09-.043.145-.063.2a6.873,6.873,0,0,1-2.762,3.452.542.542,0,0,0-.138.118,13.2,13.2,0,0,0,3.834-1.012.319.319,0,0,1-.086.166,13.77,13.77,0,0,1-3.125,3.212.339.339,0,0,0-.154.337,15.772,15.772,0,0,1-.039,2.055,19,19,0,0,1-.581,3.5,20.24,20.24,0,0,1-4.652,8.637,18.424,18.424,0,0,1-9.521,5.612,21.384,21.384,0,0,1-2.656.445,20.811,20.811,0,0,1-3.216.079,19.134,19.134,0,0,1-6.94-1.65,19.568,19.568,0,0,1-2.381-1.259C6117.189,1602.866,6117.14,1602.832,6117.089,1602.8Zm18.6.238h.041c0-.027,0-.054-.005-.081h-.028C6135.693,1602.984,6135.691,1603.01,6135.689,1603.037Z",
    transform: "translate(-6117.089 -1578.466)",
    fill: "#0487ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13929",
    "data-name": "Path 13929",
    d: "M6335.521,1862.415c0-.027,0-.053.007-.08h.028c0,.027,0,.054.005.081Z",
    transform: "translate(-6316.521 -1837.644)",
    fill: "#0487ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132",
    transform: "translate(16.16 20.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13930",
    "data-name": "Path 13930",
    d: "M6087.983,1578.4a14.213,14.213,0,0,0,7.2-1.146,12.66,12.66,0,0,0,2.9-1.767,9.173,9.173,0,0,1-1.672-.271,6.927,6.927,0,0,1-3.991-2.945,6.759,6.759,0,0,1-.739-1.559c.077.005.135,0,.191.013a6.8,6.8,0,0,0,2.725-.112.446.446,0,0,0,.138-.06,6.962,6.962,0,0,1-4.692-3.552,6.76,6.76,0,0,1-.805-3.282,7.666,7.666,0,0,0,1.513.607,6.03,6.03,0,0,0,1.576.222,6.939,6.939,0,0,1-3.026-5.952,6.637,6.637,0,0,1,.913-3.243,19.722,19.722,0,0,0,10.23,6.587,18.7,18.7,0,0,0,4.039.621c-.02-.122-.034-.219-.052-.316a6.871,6.871,0,0,1,5.207-7.984,6.742,6.742,0,0,1,6.5,1.872.271.271,0,0,0,.278.092,14.026,14.026,0,0,0,4-1.51c.053-.03.107-.058.2-.107-.028.09-.043.145-.063.2a6.869,6.869,0,0,1-2.761,3.452.555.555,0,0,0-.138.118,13.192,13.192,0,0,0,3.835-1.012.32.32,0,0,1-.086.167,13.779,13.779,0,0,1-3.125,3.212.339.339,0,0,0-.154.337,15.857,15.857,0,0,1-.039,2.055,19,19,0,0,1-.581,3.5,20.245,20.245,0,0,1-4.652,8.637,18.426,18.426,0,0,1-9.522,5.612,21.338,21.338,0,0,1-2.655.445,20.811,20.811,0,0,1-3.216.079,19.131,19.131,0,0,1-6.94-1.65,19.647,19.647,0,0,1-2.382-1.259C6088.084,1578.462,6088.034,1578.428,6087.983,1578.4Zm18.6.238h.04c0-.027,0-.054-.005-.081h-.028C6106.588,1578.58,6106.586,1578.606,6106.584,1578.633Z",
    transform: "translate(-6087.983 -1554.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13931",
    "data-name": "Path 13931",
    d: "M6301.826,1831.126c0-.027,0-.053.007-.08h.028c0,.027,0,.054.005.081Z",
    transform: "translate(-6283.226 -1806.954)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiiter);
export default __webpack_public_path__ + "static/media/twiiter.07803439d623d4eeec1fddcc4cca59cd.svg";
export { ForwardRef as ReactComponent };